import React, { FC } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import NcFileVersions from '@components/ncFileVersions';
import { connect } from 'react-redux';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { Machine } from '@interfaces/machines';

interface NCFileVersionsProps extends NavigationProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  selectedItem: Machine;
}
interface NCFileVersionsProps extends NavigationProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  selectedItem: Machine;
}

const NCFileVersionsComponent: FC<NCFileVersionsProps> = ({ lg, ncFileData, selectedItem }) => {
  return (
    <MachinesProvider lg={lg} panelViewMode={false} onBack={() => {}} getList={(props) => <TimelineItemsList {...props} />}>
      <View style={MACHINES_PAGES_CONTAINER_STYLES}>
        <NcFileVersions
          ncFileId={selectedItem?.machineStatus?.ncFileId}
          ncFile={ncFileData.data}
          machineId={selectedItem?.machineId || selectedItem?.id}
          loaded={ncFileData.wasLoaded && ncFileData.data?.ncFileId === selectedItem?.machineStatus?.ncFileId}
          shouldLoadNcFile
          enableResponsiveTwoColumnView
          forceTwoColumnOnNativeTablet
        />
      </View>
    </MachinesProvider>
  );
};

const NCFileVersions = connect(
  ({ details: { ncFileData }, machines: { selectedItem } }) => ({ ncFileData, selectedItem }),
  {}
)(NCFileVersionsComponent);

export { NCFileVersions };
